<template>
  <div v-show="isShow.isPTShow" class="recordbox">
    <div class="reTxt slideIn1"></div>
    <div class="reContent slideIn2">
      <div class="rEmail">
        <div class="rt rt1"><input type="text" class="rname" placeholder="姓名" maxlength="12" /><span class="z1"></span><input type="text" class="rcity" placeholder="城市" maxlength="10" /><span class="z2"></span></div>
        <div class="rt rt2"><span class="z3"></span><span class="z4"><span class="jt"></span></span></div>
        <select id="nan" class="myselect nan" @change="xz">
          <option value="">请选择</option>
          <option value="mm2">初心不忘，天生要强</option>
          <option value="mm3">心有所向，自带光芒</option>
          <option value="mm4">魂有所寄，心有所依</option>
          <option value="mm5">步履坚实，内心坦荡</option>
          <option value="mf1">做得完工作，爱不完生活</option>
          <option value="mf2">和希望并肩，与热爱同行</option>
          <option value="mf3">被生活温柔以待</option>
          <option value="mf4">日渐成熟，不忘天真</option>
          <option value="mf5">生活总有新奇</option>
          <option value="mf6">有好风景，也有小确幸</option>
        </select>
        <select id="nv" class="myselect nv" @change="xz2">
          <option value="">请选择</option>
          <option value="fm2">初心不忘，天生要强</option>
          <option value="fm3">心有所向，自带光芒</option>
          <option value="fm4">魂有所寄，心有所依</option>
          <option value="fm5">步履坚实，内心坦荡</option>
          <option value="ff1">做得完工作，爱不完生活</option>
          <option value="ff2">和希望并肩，与热爱同行</option>
          <option value="ff3">被生活温柔以待</option>
          <option value="ff4">日渐成熟，不忘天真</option>
          <option value="ff5">生活总有新奇</option>
          <option value="ff6">有好风景，也有小确幸</option>
        </select>
        <div class="rt rt3"><input type="text" class="rzhufu" placeholder="点击选择你的中秋寄语" maxlength="15" /></div>
      </div>
      <div class="rtip">点击灰字进行编辑</div>
      <div class="rSubmitBtn" @click="showNext"></div>
    </div>
  </div>
</template>

<script>
import { titleData } from './title.js'

export default {
  name: 'PageTwo',
  props: {
    isShow: {
      type: Object
    },
    subselectsex:{
      type:String
    }
  },
  data () {
    return {
      tData: titleData,
      zhufu1: '',
      zhufu2: ''
    }
  },
  methods: {
    showNext () {
      let name=$('.rname').val()
      let city=$('.rcity').val()
      let zhufu=$('.rzhufu').val()

      if(name==''){
        alert('姓名还没有输入哦！')
        return
      }

      if(city==''){
        alert('城市还没有输入哦！')
        return
      }

      if(zhufu==''){
        alert('中秋寄语还没有选择哦！')
        return
      }

      this.isShow.isPTShow = false
      this.isShow.isPRShow = true

      let data={
        name:name.slice(0,5),
        city:city.slice(0, 4),
        zhufu1: this.zhufu1,
        zhufu2: this.zhufu2
      }
      this.$emit('gogame',data)
      setTimeout(() => {
        $('.rname').val('')
        $('.rcity').val('')
        $('.rzhufu').val('')
      }, 500)
    },
    xz(o){
      let vv=o.target.value
      this.zhufu1 = vv
      this.mychooice(vv)
    },
    xz2(o){
      let vv=o.target.value
      this.zhufu2 = vv
      this.mychooice(vv)
    },
    mychooice(s){
      console.log(s)
      const key = s.slice(1)
      const value = this.tData[key]
      $('.rzhufu').val(value)
      if(s=='手动输入'){
        //用户手动输入
        $('.rzhufu').val('')
        $('.myselect').css({'height':'80px'})
      }else{
        $('.rzhufu').val(value)
        $('.myselect').css({'height':'80px'})
      }
    }
  },
  watch:{
    subselectsex(){
      if(this.subselectsex === '0'){
        $('#nv').hide()
        $('#nan').show()
      }else{
        $('#nan').hide()
        $('#nv').show()
      }
    }
  },
  mounted(){
    window.alert = function(name){
      var iframe = document.createElement("IFRAME");
      iframe.style.display="none";
      iframe.setAttribute("src", 'data:text/plain,');
      document.documentElement.appendChild(iframe);
      window.frames[0].window.alert(name);
      iframe.parentNode.removeChild(iframe);
    }
  }
}
</script>

<style lang="less" scoped>
  .recordbox{
    background-image: url(./bg.jpg);
    background-size:100% 100%;
    width: 100%;
    height: 100%;
    position: relative;

    .reTxt{
      background-image: url(./t1.png);
      background-size:100% auto;
      background-repeat: no-repeat;
      width: 90%;
      height: 10.625rem /* 170/16 */;
      position: absolute;
      left: 5%;
      top: 10vh;
    }

    .reContent{
      width: 90%;
      position: absolute;
      left: 5%;
      top: 34vh;
      background-image: url(./xfbg.png);
      background-size:100% auto;
      background-repeat: no-repeat;
      background-position: 0 0;
    }

    .rEmail{
      padding: 5vh 10vw 17.5vh;
      position: relative;
    }

    .rname,.rcity,.rzhufu,.rzhufu2{
      border-bottom: 1px solid #000;
      height: 30px;
      line-height: 30px;
      text-align: center;
      border-radius: 0;
    }
    .rzhufu{
      width: 100%;
    }

    .rzhufu2{
      width: 100%;
      display: none;
    }

    .rt{
      overflow: hidden;
      padding-bottom: 15px;
    }

    .rname,.rcity{
      width: 23vw;
      margin: 0 5px;
    }

    .rname{
      margin-left: 0;
    }

    .z1,.z2,.z3{
      height: 30px;
      background-size:100% auto;
      display: inline-block;
      background-repeat: no-repeat;
      background-position: center center;
    }
    .z1{
      width: 1.875/2rem /* 30/16 */;
      height: 1.9375/2rem /* 31/16 */;
      background-image: url(./z1.png);
    }
    .z2{
      width: 6.0625/2rem /* 97/16 */;
      height: 2.0625/2rem /* 33/16 */;
      background-image: url(./z2.png);
      float: right;
      display: block;
      height: 30px;
    }
    .z3{
      width: 15.75/2rem /* 252/16 */;
      height: 2.125/2rem /* 34/16 */;
      background-image: url(./z3.png);
      float: left;
      height: 30px;
    }

    .z4{
      border-bottom: 1px solid #000;
      height: 30px;
      width: 30vw;
      display: block;
      float: right;
      text-align: right;
    }

    .jt{
      width: 1.5625/2rem /* 25/16 */;
      height: 1/2rem /* 16/16 */;
      margin: 0 auto;
      background-image: url(./z4.png);
      background-repeat: no-repeat;
      background-size:100% auto;
      display: block;
      float: right;
      margin-top: 10px;
    }

    .rtip{
      text-align: center;
      margin: 0 0 30px;
    }

    .rSubmitBtn{
      width: 14.3125/2rem /* 229/16 */;
      height:6.4375/2rem /* 103/16 */;
      margin: 0 auto;
      background-image: url(./btn.png);
      background-size:100% auto;
      background-repeat: no-repeat;
    }
    .jytxt{
      text-align: center;
      color: #999;
      border-bottom: 1px solid #000;
      height: 30px;
      line-height: 30px;
    }

    .myselect{
      display: block;
      position: absolute;
      width: 78%;
      height: 80px;
      top: 28%;
      opacity: 0;
    }

    #nv{
      display: none;
    }
  }

  .slideIn1 {
    animation: slideIn1 1s linear;
  }

  .slideIn2 {
    animation: slideIn2 2s linear;
  }

  @keyframes slideIn1 {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes slideIn2 {
    0%, 55% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
</style>
